import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumberParenthesesHyphenOnly]'
})
export class NumberParenthesesHyphenOnlyDirective {
  private regex: RegExp = /^\(\d{3}\) \d{3}-\d{4}$/;

  // Handles paste event to clean up input before it reaches input handler
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const numericOnly = pastedText.replace(/\D/g, '').slice(0, 10); // keep only digits, max 10
    const formatted = this.formatInput(numericOnly);

    const input = event.target as HTMLInputElement;
    input.value = formatted;

    // Manually trigger input event for Angular to pick up changes
    input.dispatchEvent(new Event('input'));
  }

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let inputValue = input.value.replace(/[^\d]/g, ''); // Remove non-digits

    if (inputValue.length === 1) {
      input.value = `(${inputValue}`;
    } else if (inputValue.length > 1 && inputValue.length <= 3) {
      input.value = `(${inputValue}`;
    } else if (inputValue.length <= 6) {
      input.value = `(${inputValue.slice(0, 3)}) ${inputValue.slice(3)}`;
    } else if (inputValue.length <= 10) {
      input.value = `(${inputValue.slice(0, 3)}) ${inputValue.slice(3, 6)}-${inputValue.slice(6)}`;
    } else {
      inputValue = inputValue.slice(0, 10);
      input.value = `(${inputValue.slice(0, 3)}) ${inputValue.slice(3, 6)}-${inputValue.slice(6)}`;
    }

    if (inputValue === '' || input.value === '') {
      input.value = '';
    }
  }

  private formatInput(value: string): string {
    const match = value.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      const [, part1, part2, part3] = match;
      if (part3) {
        return `(${part1}) ${part2}-${part3}`;
      } else if (part2) {
        return `(${part1}) ${part2}`;
      } else if (part1) {
        return `(${part1}`;
      }
    }
    return '';
  }

}